<template>
  <div class="modal is-active">
    <div class="modal-background" />
    <!-- <component :is="componentMap[modalComponent]" /> -->
  </div>
</template>
<script setup>
import { shallowRef, computed, onBeforeUnmount, onMounted } from 'vue'
import { useModal } from '@/composables/useModal.js'

// Import modal components
// import ModalGallery from './ModalGallery.vue'
// import InstantBasketItems from './forms/InstantBasketItems.vue'
// import Confirmation from './Confirmation.vue'
// import QuoteDetails from './forms/Details.vue'

const modal = useModal()

const modalComponent = computed(() => modal.getModalComponent.value)

// const componentMap = shallowRef({
//   ModalGallery,
//   // InstantBasketItems,
//   // Confirmation,
//   // QuoteDetails,
// })

// computed: mapGetters({
//   open: 'getModalStatus',
//   component: 'getModalComponent',
// }),
onMounted(() => {
  // Add hash to location so we can reverse it on closing the modal
  window.location.hash = 'modal'
  window.addEventListener('keyup', handleKeys)
  window.addEventListener('popstate', handleBack, {
    once: true,
  })
})
onBeforeUnmount(() => {
  window.removeEventListener('keyup', handleKeys)
  window.removeEventListener('keyup', handleBack)
})

function handleKeys(e) {
  if (e.keyCode === 27) {
    modal.closeModal()
  }
}
function handleBack() {
  modal.closeModal()
  // Stay on the current page.
  return false
}
</script>
